import { Component, ContentChild, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from 'ngx-boot-modal';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.css']
})
export class InfoModalComponent {
  @Input() title: string;
  @Input() titleParams: { [key: string]: any };
  @Input() message: string;
  @Input() messageParams = [];
  @Input() acceptLabel = 'shared.info.accept';
  @Input() hideHeaderIcon = false;
  @Input() modalClass = 'modal--confirmation';
  @Input() closeOnOutsideClick = true;
  @ViewChild(ModalComponent) modal: ModalComponent;
  @ContentChild('') content: ElementRef;
  @Output() accept = new EventEmitter();

  open() {
    this.modal.open();
  }

  onAccept() {
    this.accept.emit();
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/modals/info-modal/info-modal.component.ts